import { createBrowserHistory } from "history";
import { applyMiddleware, createStore, compose, combineReducers } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import { reducer as formReducer } from "redux-form";

import rootSaga from "./sagas";
import uiReducer from "./reducers/ui";
import editorReducer from "./reducers/editor";
import authReducer from "./reducers/auth";
import userReducer from "./reducers/user";
import modelsReducer from "./reducers/models";
import contactReducer from "./reducers/contact";
import modelExportsReducer from "./reducers/modelExports";
import foldersReducer from "./reducers/folders";
import modalsReducer from "./reducers/modals";
import localeReducer from "./reducers/locale";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const history = createBrowserHistory();

const reducers = combineReducers({
  auth: authReducer,
  editor: editorReducer,
  folders: foldersReducer,
  form: formReducer,
  modals: modalsReducer,
  models: modelsReducer,
  modelExports: modelExportsReducer,
  contact: contactReducer,
  ui: uiReducer,
  user: userReducer,
  locale: localeReducer,
  router: connectRouter(history)
});

const sagaMiddleware = createSagaMiddleware();
const routerWithHistoryMiddleware = routerMiddleware(history);
const middlewares = applyMiddleware(
  routerWithHistoryMiddleware,
  sagaMiddleware
);

const initialState = {};

const store = createStore(
  reducers,
  initialState,
  composeEnhancers(middlewares)
);

sagaMiddleware.run(rootSaga);

export default store;



// WEBPACK FOOTER //
// ./src/store.js